import Factory from '../factory';

const schema = Factory.schema('video');
const attributes = schema.getProp('attributes').getValue();

attributes.prop('src').setType(String);

export default schema;
